module.exports = __webpack_public_path__ + "static/media/insurance-01.46322eea.jpg";